import { Box, Heading, Stack, StackDivider } from "@chakra-ui/react";
import * as React from "react";
import { Copyright } from "./Copyright";
import { LinkGrid } from "./LinkGrid";
import { SocialMediaLinks } from "./SocialMediaLinks";

export const App = () => (
  <Box
    as="footer"
    role="contentinfo"
    mx="auto"
    minW="100%"
    bg="facebook.400"
    py="12"
    px={{
      base: "4",
      md: "12",
    }}
  >
    <Stack spacing="10" divider={<StackDivider />}>
      <Stack
        direction={{
          base: "column",
          lg: "row",
        }}
        spacing={{
          base: "10",
          lg: "28",
        }}
        color="white"
      >
        <Box flex="1">
          <Heading fontFamily="sans-serif" color="lavenderblush">
            आनंद टेलर्स
          </Heading>
        </Box>
        <Stack
          direction={{
            base: "column",
            md: "row",
          }}
          spacing={{
            base: "10",
            md: "20",
          }}
        >
          <LinkGrid
            spacing={{
              base: "10",
              md: "20",
              lg: "28",
            }}
            flex="1"
          />
        </Stack>
      </Stack>
      <Stack
        direction={{
          base: "column-reverse",
          md: "row",
        }}
        justifyContent="space-between"
        alignItems="center"
      >
        <Copyright />
        <SocialMediaLinks />
      </Stack>
    </Stack>
  </Box>
);
